import { render } from "./RecoverRequestPage.vue?vue&type=template&id=55a0bcca&scoped=true"
import script from "./RecoverRequestPage.vue?vue&type=script&lang=js"
export * from "./RecoverRequestPage.vue?vue&type=script&lang=js"

import "./RecoverRequestPage.vue?vue&type=style&index=0&id=55a0bcca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a0bcca"]])

export default __exports__